<template>
  <div class="content">
    <card class="card">
      <div class="row" v-if="!comments.length">
        <p style="padding-left: 20px;">댓글이 없습니다.</p>
      </div>
    </card>
    <card type="timeline" class="card-plain">
      <time-line type="simple">
        <time-line-item v-for="comment in comments" v-bind:key="comment.id" inverted badge-type="">
          <div slot="icon">
            <img v-if="!comment.profileImageFileId"
              style="width: 100%; height: 100%; border-radius: 50%; margin-bottom: 3px"
              src="@/assets/img/no_profile.png" />
            <img v-if="!!comment.profileImageFileId"
              style="width: 100%; height: 100%; border-radius: 50%; margin-bottom: 3px"
              :src="comment.profileImageFileId | imageUrlWithFileId" />
          </div>

          <div class="header" slot="header">
            <span class="badge badge-danger">{{ comment.nickname }}</span>
            <span>{{ comment.regTime | formatDateTime }}</span>
            <span>{{ comment.type }}</span>
            <span>{{ comment.stateText }}</span>
            <button v-if="comment.visibility === 1 && !comment.deletedAt" @click.prevent="onClickHide(comment.id)"
              class="btn btn-sm btn-round btn-danger">숨김</button>
            <button v-if="comment.visibility === 0 || comment.deletedAt" @click.prevent="onClickRestore(comment.id)"
              class="btn btn-sm btn-round btn-success">복구</button>
          </div>

          <template slot="content">
            <span>{{ comment.comment }}</span>
          </template>
        </time-line-item>
      </time-line>
    </card>
  </div>
</template>

<script>
import { Toast } from "@/util/Toast";
import { showAPIErrorToast } from "../../util/ErrorUtils";
import { URLUtils } from "@/util/URLUtils";
import * as _ from "lodash";
import TimeLine from "@/components/Timeline/TimeLine";
import TimeLineItem from "@/components/Timeline/TimeLineItem";
import { BaseInput, Card } from "@/components/index";
import { Alert } from "@/util/Alert";
export default {
  name: "ContentCommentsPage",
  components: {
    Card,
    BaseInput,
    TimeLine,
    TimeLineItem,
  },
  async created() {
    if (_.isEmpty(this.$route.query)) {
      await this.$router.back();
      return;
    }

    const { contentId } = this.$route.query;
    if (!contentId) {
      await this.$router.back();
    }
    this.contentId = contentId
    this.fetchComments();
  },
  data() {
    return {
      userId: null,
      comment: null,
      comments: [],
    };
  },
  methods: {
    async fetchComments() {
      const { contentId } = this.$route.query;

      const queryParams = {
        page: 1,
        pageSize: 5000,
      };

      try {
        const result = await this.$axios.get(`/homepage/community/${contentId}/comment?${URLUtils.objectToQueryString(queryParams)}`);
        this.comments = result.data.data?.map((d) => ({ ...d, type: d.parentId ? '답글' : '댓글', stateText: d.deletedAt ? '삭제' : d.visibility ? '노출' : '숨김' }));
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onClickHide(commentId) {
      if (await Alert.dangerousConfirmCancel("댓글을 숨김 처리 하시겠습니까?", "댓글 작성자에게 알림 없이 노출이 중단됩니다.")) {

        try {
          await this.$axios.patch(`/homepage/community/comment/${commentId}`, { state: 0 });
          Toast.success('숨김 처리 되었습니다.');

          this.fetchComments();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickRestore(commentId) {
      if (await Alert.dangerousConfirmCancel("댓글을 복원하시겠습니까?", "댓글 작성자에게 알림 없이 복원됩니다.")) {

        try {
          await this.$axios.patch(`/homepage/community/comment/${commentId}`, { state: 1 });
          Toast.success('복원되었습니다.');

          this.fetchComments();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  margin-bottom: 10px;
}

.header {
  span {
    margin-right: 20px;
  }
}
</style>
